@if (formattedProviderNames$ | async; as providerName) {
  <div class="nps-provider-container" [innerHTML]="'TEAM.FOR' | translate: { providername: providerName }"></div>
}
